function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24.95c6.63 0 12-5.37 12-12s-5.37-12-12-12-12 5.37-12 12 5.37 12 12 12z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 21.68c-.04 0-.07-.01-.1-.03l-5.62-3.52a.27.27 0 01-.07-.08c-.01-.01-.01-.03-.01-.04a.11.11 0 010-.08v-.01l1.83-8.37c.01-.03.02-.05.03-.08l3.79-5.17c.04-.05.1-.08.16-.08s.12.03.16.08l3.79 5.17c.02.02.03.05.03.08l1.83 8.37v.09c0 .01-.01.03-.02.04-.02.03-.04.05-.07.07l-5.62 3.52c-.04.03-.07.04-.11.04zm-4.96-3.52l4.61 2.89-.92-2.89H7.04zm6.22 0l-.92 2.89 4.61-2.89h-3.69zm-2.12 0l.86 2.71.86-2.71h-1.72zm2.25-.39h3.91l-2.5-4.42-1.41 4.42zm-2.37 0h1.97l1.55-4.87L12 8.43l-2.54 4.48 1.56 4.86zm-4.32 0h3.91L9.2 13.35l-2.5 4.42zm8.25-4.91l2.21 3.91-1.41-6.44-.8 2.53zm-6.71-2.53l-1.41 6.44 2.21-3.91-.8-2.53zm3.95-2.34l2.5 4.41.89-2.78L12.19 5v2.99zM8.42 9.62l.89 2.78 2.5-4.41V5L8.42 9.62z",
  fill: "#fff"
});

function SvgEos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "9dfc64d2154a21bf867743ed7e0139ad.svg";
export { SvgEos as ReactComponent };